import React, { Component } from 'react';
import DatePicker from 'react-toolbox/lib/date_picker';

class DatePickerComponent extends Component {
  shouldComponentUpdate(nextProps) {
    const oldValue = this.getDateValue(this.props.value);
    const newValue = this.getDateValue(nextProps.value);
    return oldValue !== newValue;
  }

  getDateValue(date) {
    return date && typeof date.valueOf === 'function' ? date.valueOf() : date;
  }

  render() {
    return <DatePicker {...this.props} />;
  }
}

export default DatePickerComponent;



// WEBPACK FOOTER //
// ./app/components/DatePicker/index.js